<template>
  <div class="modal-card" ref="element">

    <header class="modal-card-head">
      <p class="modal-card-title">{{devName}}</p>
      <p v-if="stD !== endD">{{stD}} - {{endD}}</p>
      <p v-else>{{stD}}</p>
    </header>

    <header class="modal-card-head" style="background-color:white;border-radius:0px;">
           <p style="margin-right:10px">Sort by:</p>
          <b-select v-model="sortParam">
              <option value="dur">Duration (sec)</option>
              <option value="imp">Impressions</option>
            </b-select>
    </header>

    <section class="modal-card-body" >
      <!-- <p style="margin-top:-10px">Info</p> -->
      <b-table :mobile-cards="false" :data="fullData.length > 0 ? fullData : []" striped>
        <template slot-scope="props">
          <b-table-column field="count" centered>
            {{props.row.count}}
          </b-table-column>
          <b-table-column field="itemName" label="Item name" centered>
            {{props.row.ns_item_name}}
          </b-table-column>
          <b-table-column field="durSec" label="Duration (sec)" centered>
            {{props.row.total_no_of_seconds.toLocaleString('en-US')}}
          </b-table-column>
          <b-table-column field="times" label="Impressions" centered>
            {{props.row.times.toLocaleString('en-US')}}
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>No data to display.</p>
            </div>
          </section>
        </template>
      </b-table>
     </section>
    <footer class="modal-card-foot">
      <b-button type="is-danger" @click="closeModal()">Close</b-button>
    </footer>

  </div>
</template>

<script>

export default {
  name: 'AnalyticsFull',
  props: [ 'fullData', 'stD', 'endD', 'devName' ],
  data: () => {
    return {
      sortParam: 'dur'
    }
  },
  created: function () {
    var y = 1
    for (let i = 0; i < this.fullData.length; i++) {
      this.fullData[i].count = y
      y++
    }
  },
  watch: {
    sortParam () {
      if (this.sortParam === 'imp') {
        this.fullData.sort((a, b) => parseFloat(b.times) - parseFloat(a.times))
      } else {
        this.fullData.sort((a, b) => parseFloat(b.total_no_of_seconds) - parseFloat(a.total_no_of_seconds))
      }
      var y = 1
      for (let i = 0; i < this.fullData.length; i++) {
        this.fullData[i].count = y
        y++
      }
    }
  },
  methods: {
    closeModal () {
      this.$parent.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/analytics/AnalyticsFull.vue